(function () {
  function isIosSafari() {
    var ua = navigator.userAgent;
    var isIos =
      /iP(hone|ad|od)/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isSafari = /Safari/.test(ua) && !/(CriOS|FxiOS|EdgiOS|OPiOS)/.test(ua);
    return isIos && isSafari;
  }

  if (!isIosSafari()) return;

  var STORAGE_KEY = 'collection_scroll_product_id';
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cell__item .splited_product_title');
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }

    var item = link.closest('.cell__item');
    var productId = item && item.getAttribute('data-product-id');
    if (!productId) return;

    e.preventDefault();
    try {
      sessionStorage.setItem(STORAGE_KEY, productId);
    } catch (err) {}
    window.location.href = link.href;
  });

  function restoreScroll() {
    var productId;
    try {
      productId = sessionStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return;
    }
    if (!productId) return;

    var target = document.querySelector(
      '.cell__item[data-product-id="' + productId + '"]'
    );
    if (!target) return;

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {}
    var attempts = 0;
    function jump() {
      target.scrollIntoView({ block: 'center' });
      attempts += 1;
      if (attempts < 5) {
        requestAnimationFrame(jump);
      }
    }
    requestAnimationFrame(jump);
    setTimeout(function () {
      target.scrollIntoView({ block: 'center' });
    }, 250);
  }

  window.addEventListener('pageshow', restoreScroll);
  if (document.readyState === 'complete') {
    restoreScroll();
  } else {
    window.addEventListener('load', restoreScroll);
  }
})();